import styled from 'styled-components';
import { Typography } from '../../ui/Typography';
import { Breakpoints, FontWeight } from '../../../styled/constants';

export const Description = styled(Typography)`
  line-height: 1.4;
  margin: 0;
  font-size: 14px;

  &:nth-of-type(2) {
    margin: 20px 0;
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    font-size: 20px;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    font-size: 24px;
    font-weight: ${FontWeight.thin};
  }
`;
